import useShapeAnnotationForm from "./useShapeAnnotationForm";
import { ANNOTATION_COLORS } from "../../../constants/colors";
import { useEffect } from "react";

const ShapeAnnotationForm = () => {
  const { color, setColor, resetColor, clickedAsset, debugEnabled } = useShapeAnnotationForm();

  // Reset color when the component unmounts
  useEffect(() => {
    return () => {
      resetColor();
    };
  }, []);

  return (
    <>
      {debugEnabled && (
        <>
          <label>DEBUG</label>
          {clickedAsset?.id && (
            <div className="no-gutters row p-3 mb-1 bg-dark">
              <div className="col-4">Asset Id:</div>
              <div className="col">{clickedAsset.id}</div>
            </div>
          )}
        </>
      )}
      <div className="form-group mt-3">
        <label htmlFor="shapeAnnotationColorDropdown" className="mb-1">
          Border Color
        </label>
        <select
          id="shapeAnnotationColorDropdown"
          className="form-control"
          value={color}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => setColor(e.target.value)}
        >
          {ANNOTATION_COLORS.map((color) => (
            <option key={color.value} value={color.value}>
              {color.name}
            </option>
          ))}
        </select>
      </div>
    </>
  );
};

export default ShapeAnnotationForm;
